/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo } from 'react'
import { Route } from 'react-router-dom'
import Unit from './component/unit'
import Company from './component/Company'
import SystemConfiguration from './component/SystemConfiguration'

import UnitType from './component/UnitType'
import UnitGroup from './component/unit-group/UnitGroup'
import User from './component/user'
import UserGroup from './component/user-groups'
import ESuiteMgmt from './component/esuite-management/ESuiteMgmt'
import ProcessLog from './component/ProcessLog'
import UtilityOperator from './component/UtilityOperator'
import FuelCodeMgmt from './component/FuelCodeMgmt'
import Station from './component/Station'
import PnodeAndEmktMgmt from './component/PnodeAndEmktMgmt'
import AmpCodeMgmt from './component/AmpCodeMgmt'
import CauseCodeMgmt from './component/CauseCodeMgmt'
import SystemCompMgmt from './component/SystemCompMgmt'
import GadsErrorMgmt from './component/GadsErrorMgmt'
import FailCodeMgmt from './component/FailCodeMgmt'
import NERCCapacity from './component/NERCCapacity'
import HolidayMgmt from './component/HolidayMgmt'
import PercentOwnership from './component/PercentOwnership'
import UniversalId from './component/UniversalId'
import GlobalUnitReAssignment from './component/GlobalUnitReAssignment'
import RoleProvider from './component/roles/RolesNew'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import MonthlyLock from './component/MonthlyLock'
import UnitLock from './component/UnitLock'
import CauseCodeLookup from './component/CauseCodeLookupTools'
import UserInfoChange from './component/UserInfoChange'
import EventDuraCalculator from './component/EventDuraCalculator'
import NercGroup from './component/nercgroup/NercGroup'
import OwnershipAccess from './component/OwnershipAccess'
import Guide from 'admin/component/Guide'
import SwitchBoardImport from 'switchboard/import'
import WebserviceAccess from 'admin/component/ws-access'
import WebServiceServiceLogger from './component/InOutLogFile'
import OperatingData from './component/OperatingData'
// import SchedulerComoponent from '@integec/common-react-screens/lib/integ-scheduler-ui'
import ConnectedScheduler from '../scheduler-ui'
import EventTypes from './component/EventTypes'
import WebServiceAccessWEE from './component/ws-access/WEEWebServiceAccess'
import SrpSystemCodeMgmt from './component/SrpSystemCodeMgmt'

import {
  NE_NEW_ENGLAND,
  WEE_CLIENT,
  MISO_CLIENT,
  KINDLE_CLIENT,
  EAST_GEN_CLIENT,
  NRG_CLIENT,
  TOTALENGERY_CLIENT,
  COOP_CLIENT,
  BEPC_CLIENT,
} from 'client'

import UnitExtension from './component/UnitExtension'
import RiverSystemUnit from './component/riversystem/RiverSystemUnit'
import RiverSystemRegion from './component/riversystem/RiverSystemRegion'
import { APS_CLIENT, BROOKFIELD_CLIENT, PJM_CLIENT } from '../client'
import MelComponent from './component/MelComponent'
import MelCausecode from './component/MelCausecode'
import ApsPiEntity from './component/ApsPiEntity'
import PjmGadsAcctManager from './component/PjmGadsAcctManager'
import ErrorTraceLog from './component/ErrorTraceLog'
import ApsAdMapping from './component/aps/ApsAdMapping'
import NercClassAverage from './component/newengland/NercClassAverage'
import NEUser from './component/newengland/NEUSers'
import NEUserMapping from './component/newengland/NEUserMapping'
import Unitblock from './component/newengland/Unitblock'

import MisoVerificationSeason from './component/MisoVerificationSeason'
import MisominTestDuration from './component/MisoMinTestDuration'
import MisoTestDefaultClass from './component/MisoTestDefaultClass'
import MisoUsers from './component/MisoUsers'
import MisoUserMapping from './component/MisoUserMpping'
import VerificationLock from 'pjmadmin/VerificationLock'
import BfNyIsoDerateGroup from './component/BfNyIsoDerateGroup'
import ContribCondition from './component/ContribCondition'
import MisoCompanyUsers from './component/MisoCompanyUsersMapping'
import PeakDefinition from './component/PeakDefinitation'
import PITag from './component/PITag'
import OaPeakDefinition from 'pjmadmin/PeakDefinition'
import TotalErcotMapping from 'total/TotalErcotMapping'

import {
  AdditionalEventTags,
  AdditionalMonthlyTags,
  AddnMonthlyTracking,
  MessageCategory,
  NEISOFileCreation,
  NYISOFileCreation,
  ProcessAll,
  UserMessage,
  UserMessageCategory,
  AdminMessage,
} from './component/talen'
import {
  UnitPerfGroup,
  ProfitCost,
  Card97ExtSpec,
  Card95ExtSpec,
  // PeakDefinition,
  NRGEventReportSpec,
  Holiday,
} from 'nrg-admin'
import EventReportSchedulerConfiguration from 'nrg-admin/EventReportSchedulerConfiguration'
import WsGenerationMW from './ws-interface-import/WsGenerationMW'
import WsFuelCost from './ws-interface-import/WsFuelCost'
import WsMarketPrice from './ws-interface-import/WsMarketPrice'
import WsBreakerData from './ws-interface-import/WsBreakerData'
import iifo from './component/nyiso/iifo'
import plw from './component/nyiso/plw'
import NyisoMarsParameter from './component/nyiso/MarsReportParameter'
import CoopMisoMapping from '../coop/CoopMisoMapping'
import BepcSppMapping from '../bepc/BepcSppMapping'
import AssetManagement from './component/coop/AssetManagement'
export const ToolsContainer = ({ actionPermits, envConfig }) => {
  const { isStackTraceAllowed = true } = envConfig

  const errorTraceUserScreen = useMemo(
    _ =>
      !isStackTraceAllowed &&
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ERROR_LOG_SCREEN_USER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode, isStackTraceAllowed]
  )
  const ToolError = useCallback(
    props => <ErrorTraceLog showDelete={false} {...props} />,
    []
  )

  const userMessageAccessTools = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.TALEN_USER_MESSAGE],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      <Route exact path="/admin/causecodelookup" component={CauseCodeLookup} />
      <Route exact path="/admin/userinfochange" component={UserInfoChange} />
      <Route
        exact
        path="/admin/eventduracalculator"
        component={EventDuraCalculator}
      />
      <Route key="guide" exact path="/guide" component={Guide} />
      {errorTraceUserScreen && (
        <Route
          key="errortraceuser"
          exact
          path="/errortraceuser"
          component={ToolError}
        />
      )}
      {userMessageAccessTools && (
        <Route
          key="errortraceuser"
          exact
          path="/tools/adminmessage"
          component={AdminMessage}
        />
      )}
    </React.Fragment>
  )
}

const AdminContainer = ({ actionPermits, envConfig, CLIENT }) => {
  const WindPiTag = useCallback(props => <PITag {...props} isWind />, [])
  const hasWebServiceAccessPermission = useMemo(
    _ => {
      return hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WEBSERVICE_ACCESS_PERMISSIONS],
        matchAny: true,
      })
    },
    [actionPermits, envConfig.authGodMode]
  )

  const showNercClassAvgEford = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NERC_CLASS_AVG_EFORD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const WebServiceComponent = useMemo(
    _ =>
      CLIENT === WEE_CLIENT || CLIENT === BROOKFIELD_CLIENT
        ? WebServiceAccessWEE
        : WebserviceAccess,
    [CLIENT]
  )

  const OperatingDataAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.OPERATING_DATA],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const schedulerAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SCHEDULER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const srpSystemCodeManagementAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SYSTEM_CODE_MANAGEMENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const riverSystemUnit = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.RIVER_SYSTEM_UNIT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const unitExtensionAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.UNIT_EXTENSION_MANAGEMENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const riverSystemRegion = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.RIVER_SYSTEM_REGIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const universalId = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.UNIVERSAL_ID],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const melComponent = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MEL_COMPONENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const melCausecode = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MEL_CAUSECODE],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const apsPientityPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.APS_PI_ENTITY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const showUnitBlock = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.UNIT_BLOCK],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const misoAdminTestDuration = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_MIN_TEST_DURATION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const nyisoderateGroup = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NYISO_DERATE_GROUP],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const { isStackTraceAllowed = true } = envConfig
  const errorTraceAdminScreen = useMemo(
    _ =>
      !isStackTraceAllowed &&
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.ERROR_LOG_SCREEN_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode, isStackTraceAllowed]
  )
  const misoAdminTestDefault = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_TEST_DEFAULT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const misoAdminVerificationSeason = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_VERIFICATION_SEASON],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const verificationLock = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.VERIFICATION_LOCK],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const hasAdminPeackDefinitation = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PEAK_DEFINITATION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const ContribConditionView = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CONTRIB_CONDITION],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const piTagAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.PITAG_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const assetManagementAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.COOP_ASSET_MANAGEMENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    hasAccesPermits({
      authGodMode: envConfig.authGodMode,
      actionPermits,
      eventActions: [
        ScreenPermissions.ACCESS_PERMISSIONS,
        ScreenPermissions.IT_REGISTRATION,
        ScreenPermissions.CHANGE_PERMISSIONS,
      ],
      matchAny: true,
    }) && (
      <Route
        key="admin"
        path="/admin"
        render={() => (
          <>
            <Route
              key="admin-peak-definition"
              exact
              path="/admin/oa-peak-definition"
              component={OaPeakDefinition}
            />
            {verificationLock && (
              <Route
                exact
                path="/verification-lock"
                component={VerificationLock}
              />
            )}
            {ContribConditionView && (
              <Route
                exact
                path="/admin/contrib-cond"
                component={ContribCondition}
              />
            )}
            {nyisoderateGroup && (
              <Route
                exact
                path="/admin/nyisoderategroup"
                component={BfNyIsoDerateGroup}
              />
            )}

            {CLIENT === MISO_CLIENT && [
              <Route
                key="miso-users"
                exact
                path="/admin/miso-users"
                component={MisoUsers}
              />,
              <Route
                key="miso-users-mapping"
                exact
                path="/admin/miso-users-mapping"
                component={MisoUserMapping}
              />,
              <Route
                key="miso-company-users-mapping"
                exact
                path="/admin/miso-company-users-mapping"
                component={MisoCompanyUsers}
              />,
            ]}

            {misoAdminTestDuration && (
              <Route
                key="miso-verfi-min"
                exact
                path="/admin/veriftestsche"
                component={MisominTestDuration}
              />
            )}
            {misoAdminTestDefault && (
              <Route
                key="miso-verfi-default"
                exact
                path="/admin/veriftestdefault"
                component={MisoTestDefaultClass}
              />
            )}
            {misoAdminVerificationSeason && (
              <Route
                key="miso-verfi-season"
                exact
                path="/admin/verifseason"
                component={MisoVerificationSeason}
              />
            )}
            {CLIENT === PJM_CLIENT && (
              <Route
                key="pjm-gads-acctpmgr"
                exact
                path="/admin/gads-acctmanager"
                component={PjmGadsAcctManager}
              />
            )}
            {CLIENT === NE_NEW_ENGLAND && [
              <Route
                key="iso-ne-users"
                exact
                path="/admin/iso-ne-users"
                component={NEUser}
              />,
              <Route
                key="iso-ne-users-mapping"
                exact
                path="/admin/iso-ne-users-mapping"
                component={NEUserMapping}
              />,
            ]}
            {showUnitBlock && (
              <Route
                key="unit-block"
                exact
                path="/admin/unit-block"
                component={Unitblock}
              />
            )}
            {CLIENT === TOTALENGERY_CLIENT && (
              <Route
                key="total-ercot-mapping"
                exact
                path="/admin/total-ercot-mapping"
                component={TotalErcotMapping}
              />
            )}
            {CLIENT === COOP_CLIENT && (
              <Route
                key="coop-miso-mapping"
                exact
                path="/admin/coop-miso-mapping"
                component={CoopMisoMapping}
              />
            )}
            {CLIENT === BEPC_CLIENT && (
              <Route
                key="bepc-spp-mapping"
                exact
                path="/admin/bepc-spp-mapping"
                component={BepcSppMapping}
              />
            )}
            {apsPientityPermission && (
              <Route
                key="pi-entity"
                exact
                path="/admin/pi-entity"
                component={ApsPiEntity}
              />
            )}
            {showNercClassAvgEford && (
              <Route
                key="nercclassavgeford"
                exact
                path="/admin/nercclassavgeford"
                component={NercClassAverage}
              />
            )}
            {CLIENT === APS_CLIENT && (
              <Route
                key="aps-ad-mapping"
                exact
                path="/admin/ad-mapping"
                component={ApsAdMapping}
              />
            )}
            {melCausecode && (
              <Route
                key="mel-casecode"
                exact
                path="/admin/mel-causecode"
                component={MelCausecode}
              />
            )}
            {melComponent && (
              <Route
                key="mel-component"
                exact
                path="/admin/mel-component"
                component={MelComponent}
              />
            )}
            {OperatingDataAccess && (
              <Route
                key="operatingdata"
                exact
                path="/admin/operatingdata"
                component={OperatingData}
              />
            )}
            {schedulerAccess && (
              <Route
                key="scheduler"
                exact
                path="/admin/scheduler"
                component={ConnectedScheduler}
              />
            )}
            {srpSystemCodeManagementAccess && (
              <Route
                key="systemcode"
                exact
                path="/admin/systemcode"
                component={SrpSystemCodeMgmt}
              />
            )}
            {unitExtensionAccess && (
              <Route
                key="unitextension"
                exact
                path="/admin/unit-extension"
                component={UnitExtension}
              />
            )}
            <Route
              exact
              path="/admin/eventypes"
              key="eventtype"
              component={EventTypes}
            />
            <Route
              exact
              path="/admin/nercgroup"
              key="nercgroup"
              component={NercGroup}
            />
            <Route
              exact
              path="/admin/monthlylock"
              key="monthlylock"
              component={MonthlyLock}
            />
            <Route exact path="/admin/unitlock" component={UnitLock} />
            <Route exact path="/admin/unit" component={Unit} />
            <Route exact path="/admin/role" component={RoleProvider} />
            <Route exact path="/admin/company" component={Company} />
            <Route
              exact
              path="/admin/system-configuration"
              component={SystemConfiguration}
            />
            <Route exact path="/admin/unit-type" component={UnitType} />
            <Route exact path="/admin/unit-group" component={UnitGroup} />
            <Route exact path="/admin/users" component={User} />
            <Route exact path="/admin/user-groups" component={UserGroup} />
            <Route
              exact
              path="/admin/esuite-management"
              component={ESuiteMgmt}
            />
            <Route exact path="/admin/process-log" component={ProcessLog} />
            <Route
              exact
              path="/admin/utility-operator"
              component={UtilityOperator}
            />
            <Route
              exact
              path="/admin/fuel-code-mgmt"
              component={FuelCodeMgmt}
            />
            <Route exact path="/admin/station" component={Station} />
            <Route
              exact
              path="/admin/pnode-emkt-mgmt"
              component={PnodeAndEmktMgmt}
            />
            <Route exact path="/admin/amp-code-mgmt" component={AmpCodeMgmt} />
            <Route
              exact
              path="/admin/cause-code-mgmt"
              component={CauseCodeMgmt}
            />
            <Route
              exact
              path="/admin/system-component-mgmt"
              component={SystemCompMgmt}
            />
            <Route
              exact
              path="/admin/gads-error-mgmt"
              component={GadsErrorMgmt}
            />
            <Route
              exact
              path="/admin/fail-code-mgmt"
              component={FailCodeMgmt}
            />
            <Route exact path="/admin/nerc-capacity" component={NERCCapacity} />
            <Route exact path="/admin/holiday-mgmt" component={HolidayMgmt} />
            <Route
              exact
              path="/admin/percent-ownership"
              component={PercentOwnership}
            />
            {universalId && (
              <Route exact path="/admin/universal-id" component={UniversalId} />
            )}
            <Route
              exact
              path="/admin/global-unit-reassignment"
              component={GlobalUnitReAssignment}
            />
            <Route exact path="/admin/iifo-outage" component={iifo} />
            <Route exact path="/admin/iifo-plw" component={plw} />
            <Route
              exact
              path="/admin/mars-report-param"
              component={NyisoMarsParameter}
            />
            {piTagAccess && (
              <Route key="pitag" exact path="/admin/pi-tag" component={PITag} />
            )}
            {piTagAccess && (
              <Route
                key="pitag-wind"
                exact
                path="/admin/pi-tag-wind"
                component={WindPiTag}
              />
            )}
            <Route
              key="owenershipaccess"
              exact
              path="/admin/ownership-access"
              component={OwnershipAccess}
            />
            <Route
              exact
              path="/admin/card97-ext-spec"
              component={AdditionalEventTags}
            />
            <Route
              exact
              path="/admin/asset-management"
              component={AssetManagement}
            />
            <Route
              exact
              path="/admin/card95-ext-spec"
              component={AdditionalMonthlyTags}
            />
            <Route
              exact
              path="/admin/monthly-error-log"
              component={ProcessAll}
            />
            <Route
              exact
              path="/admin/card95-extension"
              component={AddnMonthlyTracking}
            />
            <Route
              exact
              path="/admin/neiso-file-creation"
              component={NEISOFileCreation}
            />
            <Route
              exact
              path="/admin/nyiso-file-creation"
              component={NYISOFileCreation}
            />
            <Route exact path="/admin/user-message" component={UserMessage} />
            <Route
              exact
              path="/admin/user-message-category"
              component={UserMessageCategory}
            />
            <Route
              exact
              path="/admin/message-category"
              component={MessageCategory}
            />

            {riverSystemUnit && (
              <Route
                key="riversystemunit"
                exact
                path="/admin/river-system-unit"
                component={RiverSystemUnit}
              />
            )}
            {riverSystemRegion && (
              <Route
                key="riversystemregion"
                exact
                path="/admin/river-system-region"
                component={RiverSystemRegion}
              />
            )}
            <Route
              key="unit-perf-group"
              exact
              path="/admin/unit-perf-group"
              component={UnitPerfGroup}
            />
            {/* <Route
              key="user-message-category"
              exact
              path="/admin/user-message-category"
              component={UserMessageCategory}
            /> */}
            <Route
              key="admin-message"
              exact
              path="/admin/admin-message"
              component={AdminMessage}
            />
            <Route
              key="profit-cost"
              exact
              path="/admin/profit-cost"
              component={ProfitCost}
            />
            <Route
              key="event-report-spec"
              exact
              path="/admin/event-report-spec"
              component={EventReportSchedulerConfiguration}
            />
            {/* <Route
              key="card97-ext-spec"
              exact
              path="/admin/card97-ext-spec"
              component={Card97ExtSpec}
            /> */}
            {/* <Route
              key="card95-ext-spec"
              exact
              path="/admin/card95-ext-spec"
              component={Card95ExtSpec}
            /> */}
            <Route
              key="holiday"
              exact
              path="/admin/nrg-holiday"
              component={Holiday}
            />
            {/* <Route
              key="peak-definition"
              exact
              path="/admin/peak-definition"
              component={PeakDefinition}
            /> */}
            <Route
              key="ws-generationmw"
              exact
              path="/admin/ws-generationmw"
              component={WsGenerationMW}
            />
            <Route
              key="ws-fuelcost"
              exact
              path="/admin/ws-fuelcost"
              component={WsFuelCost}
            />
            <Route
              key="ws-marketprice"
              exact
              path="/admin/ws-marketprice"
              component={WsMarketPrice}
            />
            <Route
              key="ws-breakerdata"
              exact
              path="/admin/ws-breakerdata"
              component={WsBreakerData}
            />
            {hasAccesPermits({
              authGodMode: envConfig.authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.PROCESS_DATA_WITH_FILE_UPLOAD],
              matchAny: true,
            }) ? (
              <Route
                exact
                path="/admin/switchboard-import"
                key="switchboard-import"
                component={SwitchBoardImport}
              />
            ) : null}
            {hasWebServiceAccessPermission && (
              <React.Fragment>
                <Route
                  key="webserviceaccess"
                  exact
                  path="/admin/webserviceaccess"
                  component={WebServiceComponent}
                />
                <Route
                  key="webserviceaccesslog"
                  exact
                  path="/admin/webserviceaccesslog"
                  component={WebServiceServiceLogger}
                />
              </React.Fragment>
            )}
            {errorTraceAdminScreen && (
              <Route
                key="admin-errortraceadmin"
                exact
                path="/admin/errortraceadmin"
                component={ErrorTraceLog}
              />
            )}
            {(hasAdminPeackDefinitation ||
              [KINDLE_CLIENT, EAST_GEN_CLIENT, NRG_CLIENT].includes(
                CLIENT
              )) && (
              <Route
                key="admin-peak-definition-a"
                exact
                path="/admin/peak-definition"
                component={PeakDefinition}
              />
            )}
          </>
        )}
      />
    )
  )
}

export default AdminContainer
